/**
 * Check if user scopes satisfy a required scope.
 *
 * Rules:
 * - Exact match: user has "admin", required "admin" → true
 * - Parent grants child: user has "admin", required "admin:company:offices" → true
 * - Child does NOT grant parent: user has "admin:company", required "admin" → false
 */
export function hasScope(userScopes: string[] | undefined, requiredScope: string): boolean {
  if (!userScopes || userScopes.length === 0) return false;
  return userScopes.some(
    (s) => s === requiredScope || requiredScope.startsWith(s + ":"),
  );
}

/** Check if user scopes satisfy ANY of the required scopes. */
export function hasAnyScope(userScopes: string[] | undefined, requiredScopes: string[]): boolean {
  return requiredScopes.some((r) => hasScope(userScopes, r));
}

/** Check if user scopes match a scope requirement (single string or OR-array). */
export function matchesScope(userScopes: string[] | undefined, scope: string | string[]): boolean {
  if (Array.isArray(scope)) return hasAnyScope(userScopes, scope);
  return hasScope(userScopes, scope);
}

const PRODUCT_ROUTES: { scope: string; href: string }[] = [
  { scope: "iq_suite:multi_rater", href: "/multi-rater" },
  { scope: "iq_suite:market_finder", href: "/market-finder" },
  { scope: "iq_suite:property", href: "/property" },
  { scope: "iq_suite:bar_tavern", href: "/bar-tavern" },
  { scope: "iq_suite:transportation", href: "/transportation" },
  { scope: "iq_suite:property_insurance", href: "/property-insurance" },
];

/** Return the first product route the user has access to, by priority. */
export function getDefaultRoute(userScopes: string[] | undefined): string {
  if (!userScopes || userScopes.length === 0) return "/auth/login";
  for (const { scope, href } of PRODUCT_ROUTES) {
    if (hasScope(userScopes, scope)) return href;
  }
  return "/multi-rater";
}
